import { Component, computed, effect, inject, input } from '@angular/core';
import { DiagnosisObject } from '@it2go/types';
import {
    SERVICE_SETTINGS_DASHBOARD_ANAMNESIS_FIELDS_DEFAULT,
    ServiceSettingsDashboardAnamnesisFieldsType,
} from '@libs/types/src/services/types/common-service-settings.type';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { TranslatePipe } from '@ngx-translate/core';
import { Tag } from '@openng/optimus-ui/tag';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { DoctorChipComponent } from '../../../kit/doctor-chip/doctor-chip.component';
import { EmptyStateComponent } from '../../../../modules/shared/components/empty-state/empty-state.component';
import { LoadingComponent } from '../../../kit/loading/loading.component';
import { ShortDatePipe } from '../../../../modules/shared/pipes/short-date.pipe';
import { FolderAnamnesisWidgetStore } from './folder-anamnesis-widget.store';
import { folderAnamnesisWidgetFrag } from './folder-anamnesis-widget.query';

@Component({
    selector: 'app-folder-anamnesis-widget',
    templateUrl: './folder-anamnesis-widget.component.html',
    styleUrl: './folder-anamnesis-widget.component.scss',
    providers: [FolderAnamnesisWidgetStore],
    imports: [
        TranslatePipe,
        EmptyStateComponent,
        LoadingComponent,
        ShortDatePipe,
        Tag,
        Tooltip,
        DoctorChipComponent,
    ],
})
export class FolderAnamnesisWidgetComponent {

    protected readonly store = inject(FolderAnamnesisWidgetStore);

    public readonly folderIds = input.required<number[]>();
    public readonly visibleFields = input<ServiceSettingsDashboardAnamnesisFieldsType>(
        SERVICE_SETTINGS_DASHBOARD_ANAMNESIS_FIELDS_DEFAULT,
    );

    protected readonly diagnoses = computed<DiagnosisObject[]>(() => {
        const anamnesis = this.store.anamnesis();
        if (!anamnesis) return [];

        const diagnoses = [anamnesis.diagnosis, ...(anamnesis.secondaryDiagnoses ?? [])]
            .filter((diagnosis): diagnosis is DiagnosisObject => !!diagnosis?.code);

        return [...new Map(diagnoses.map((diagnosis) => [diagnosis.code, diagnosis])).values()];
    });

    constructor() {
        effect(() => {
            const folderIds = this.folderIds();
            if (!folderIds.length) return;

            const filter = new FilterBuilder()
                .where('folderId', folderIds, 'IN')
                .sort('updatedAt', 'DESC')
                .limit(1);

            this.store.api.getAnamneses(filter.filter(), folderAnamnesisWidgetFrag).then();
        });
    }
}
